import AppointmentDisplay from './AppointmentDisplay';
import NoAppointments from './AppointmentDisplay/NoAppointments';
import { Props } from './AppointmentDisplay/common';

const PrevisitScheduleAppointment: React.FC<Props> = ({
  availableEhrTimeSlots,
  practices,
  providers,
  orders,
  navigateToNextPage,
  onAppointmentSelected,
  practice,
  encounter,
  fieldConfig,
  patientOrder,
  mainProviderUserId,
  patientPcpPreferred,
  filterProps,
}) => {
  return (
    <>
      {availableEhrTimeSlots.length ? (
        <AppointmentDisplay
          availableEhrTimeSlots={availableEhrTimeSlots}
          practices={practices}
          providers={providers}
          orders={orders}
          navigateToNextPage={navigateToNextPage}
          onAppointmentSelected={onAppointmentSelected}
          practice={practice}
          encounter={encounter}
          fieldConfig={fieldConfig}
          patientOrder={patientOrder}
          mainProviderUserId={mainProviderUserId}
          patientPcpPreferred={patientPcpPreferred}
          filterProps={filterProps}
        />
      ) : (
        <NoAppointments
          navigateToNextPage={navigateToNextPage}
          practice={practice}
          encounter={encounter}
          fieldConfig={fieldConfig}
        />
      )}
    </>
  );
};

export default PrevisitScheduleAppointment;
